import React from "react";

/**
 * Field — form field wrapper for the TSR Admin.
 * Renders a bold Plus Jakarta Sans navy label above the input,
 * plus optional inline hint text below.
 */
export default function Field({ label, hint, required, children, className = "", testid }) {
  return (
    <div className={`space-y-1.5 ${className}`} data-testid={testid}>
      <label className="block text-[11px] uppercase tracking-widest text-[#1E3A8A] font-semibold font-sans">
        {label}
        {required && <span className="text-[#D2673E] ml-1">*</span>}
      </label>
      {children}
      {hint && (
        <p className="text-[11px] text-[#4B5563] leading-snug">{hint}</p>
      )}
    </div>
  );
}
